import { Box, CircularProgress, DialogActions, DialogTitle, IconButton } from '@material-ui/core'
import React from 'react'

import { makeStyles } from '@material-ui/core'
import CustomDialog from '../CustomDialog'
import CustomButton from '../CustomButton'
import CustomLabel from '../CustomLabel'
import { Close } from '@material-ui/icons'
import CustomHeading from '../CustomHeading'

const useStyles = makeStyles((theme) => ({
  image: {
    width: '80px',
  },
  button: {
    // marginRight: '10px',
    width: '140px',
    // padding: '5px',
    backgroundColor: 'grey',
    '&:hover': {
      backgroundColor: 'grey',
    },
  },
  button2: {
    // marginRight: '10px',
    width: '140px',
    // padding: '5px',
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: theme.palette.error.main,
    },
  },
  dialog: {
    padding: '0px',
    minWidth: '400px',
  },
  iconButton: { position: 'relative', top: '-18px', left: '18px' },
}))

export default function ConfirmDialog({ open, handleClose, name, handleSubmit, loading = false }) {
  const classes = useStyles()

  const handleOnSubmit = () => {
    handleSubmit()
    handleClose()
  }

  return (
    <CustomDialog open={open} handleClose={handleClose} className={classes.dialog}>
      <Box display="flex" justifyContent="space-between">
        <CustomHeading heading="Delete" />
        <IconButton color="inherit" onClick={handleClose} className={classes.iconButton}>
          <Close />
        </IconButton>
      </Box>
      <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
        Are you sure you want to delete Permanently{' '}
        <b>
          <i> {name} </i>
        </b>
        ?
      </DialogTitle>
      <br />
      <Box display="flex" justifyContent="space-between">
        <CustomButton text="Cancel" handleSubmit={handleClose} className={classes.button} />
        <CustomButton disabled={loading} text={loading ? <CircularProgress size="25px" color="inherit" /> : 'Delete'} handleSubmit={handleOnSubmit} className={classes.button2} />
      </Box>
    </CustomDialog>
  )
}
